import React from "react";

import { TreeItem } from '@mui/x-tree-view';
import _ from "lodash";
import { Card, CardContent, Typography } from "@mui/material";
import parse from "html-react-parser";

const RedditRecursiveComment = (props) => {
  const { comment, confidenceFilter } = props;

  const replies = _.get(comment, "replies", []);
  const hasReplies = replies.length > 0;

  if (comment.confidence <= confidenceFilter) {
    return null;
  }

  return (
    <TreeItem
      nodeId={comment.id}
      label={<Typography variant="h6">Rectified Username</Typography>}
    >
      <Card>
        <CardContent>
          <Typography variant='body2'>
            {parse(comment.body_html)}
          </Typography>
        </CardContent>
      </Card>
      {hasReplies &&
        comment.replies.map((reply) => {
          return (
            <RedditRecursiveComment
              key={reply.id}
              comment={reply}
              confidenceFilter={confidenceFilter}
            />
          );
        })}
    </TreeItem>
  );
};

export default RedditRecursiveComment;
